import { ReactNode } from 'react';
import { Button } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface ModalFormTableOfContentsItem<TKey extends string = string> {
    disabled?: boolean;
    icon: ReactNode;
    key: TKey;
    label: ReactNode;
}

interface ModalFormTableOfContentsProps<TKey extends string> {
    items: ModalFormTableOfContentsItem<TKey>[];
    onSelect: (key: TKey) => void;
    title?: ReactNode;
}

const ModalFormTableOfContents = <TKey extends string>({
    items,
    onSelect,
    title = 'Creation Steps',
}: ModalFormTableOfContentsProps<TKey>): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <nav aria-label={typeof title === 'string' ? title : 'Form sections'}>
            <div style={{ color: token.colorTextTertiary, margin: '0 0.5rem 0.75rem' }}>
                <small>{title}</small>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                {items.map((item) => (
                    <Button
                        key={item.key}
                        block
                        disabled={item.disabled}
                        type='text'
                        style={{ justifyContent: 'flex-start' }}
                        onClick={() => onSelect(item.key)}
                    >
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'inline-flex',
                                gap: '0.375rem',
                                height: '100%',
                                lineHeight: 1,
                            }}
                        >
                            <span
                                aria-hidden='true'
                                style={{
                                    alignItems: 'center',
                                    display: 'inline-flex',
                                    justifyContent: 'center',
                                    lineHeight: 0,
                                }}
                            >
                                {item.icon}
                            </span>
                            <span
                                style={{
                                    alignItems: 'center',
                                    display: 'inline-flex',
                                    height: '100%',
                                    lineHeight: 1.25,
                                }}
                            >
                                {item.label}
                            </span>
                        </span>
                    </Button>
                ))}
            </div>
        </nav>
    );
};

export default ModalFormTableOfContents;
